// extracted by mini-css-extract-plugin
export var summaryDetails = "CustomizeSidebar_summaryDetails__s3f6f";